// extracted by mini-css-extract-plugin
export default {"Full":"ImageWindow_Full__Fbwf3","FullImage":"ImageWindow_FullImage__6PwkL","ImageDimmer":"ImageWindow_ImageDimmer__kRF4Z"};